import { createSlice } from "@reduxjs/toolkit";
import { generateMcqs, getScores, submitMcqs } from "../Services/mcq.service";



const initialState ={
        loading:false,
        mcqMarks:"",
        mcqMarksOnGetScore:"",
        course_generated:""
}

const mcqSlice = createSlice({
    name: "mcq",
    initialState,
    reducers: {},
    
    extraReducers: (builder) => {
      builder
        .addCase(generateMcqs.pending, (state) => {
          state.loading = true;
        })
        .addCase(generateMcqs.fulfilled,(state)=>{
            state.loading=false;
        })
        .addCase(generateMcqs.rejected,(state)=>{
            state.loading=false;
        })
        .addCase(submitMcqs.fulfilled,(state,action)=>{
          state.mcqMarks=action.payload?.data?.score?.total_score;
        })
        .addCase(getScores.fulfilled,(state,action)=>{
          state.mcqMarksOnGetScore=action.payload?.data?.score;
          state.course_generated=action.payload?.data?.course_generated;
        })
    },
  });

export const {} = mcqSlice.actions;
export default mcqSlice.reducer;